export const Sizes = {
  screenWidth: window.innerWidth,
  screenHeight: window.innerHeight,
  fullWidth: "100%",
  fullHeight: "100%",
  containerWidth: 1440,
  formBoxWidth: 400,
  inputHeight: 40,
};
